import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage    from './pages/LoginPage';
import AdminLayout  from './pages/admin/AdminLayout';
import MemberLayout from './pages/member/MemberLayout';
import GroupLayout  from './pages/group/GroupLayout';

function ProtectedRoute({ children, roles }) {
  const { session, profile, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#B71C1C' }}>
      <img src="/pcea-logo.png" alt="PCEA" style={{width:56,opacity:.9,marginBottom:12}}/>
      <div style={{ color:'white', fontSize:16, fontWeight:700 }}> Loading…</div>
    </div>
  );
  if (!session) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(profile?.role)) return <Navigate to="/" replace />;
  return children;
}

function Root() {
  const { profile, loading } = useAuth();
  if (loading) return null;
  if (!profile) return <Navigate to="/login" replace />;
  const r = profile.role;
  if (['super_admin','finance_admin','evangelist_admin'].includes(r)) return <Navigate to="/admin" replace />;
  if (r === 'group_leader') return <Navigate to="/group" replace />;
  return <Navigate to="/member" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Root />} />
      <Route path="/admin/*" element={
        <ProtectedRoute roles={['super_admin','finance_admin','evangelist_admin']}>
          <AdminLayout />
        </ProtectedRoute>
      }/>
      <Route path="/member/*" element={
        <ProtectedRoute roles={['member']}>
          <MemberLayout />
        </ProtectedRoute>
      }/>
      <Route path="/group/*" element={
        <ProtectedRoute roles={['group_leader']}>
          <GroupLayout />
        </ProtectedRoute>
      }/>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" toastOptions={{
          style:   { fontFamily:'Plus Jakarta Sans,sans-serif', fontSize:13, fontWeight:600 },
          success: { style:{ background:'#2E7D32', color:'white' } },
          error:   { style:{ background:'#C62828', color:'white' } },
        }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
